import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Box,
  IconButton,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import mgmtVariantOptions from "src/services/mgmtVariantOptions";

const VariantOptionsForm = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [customerId, setCustomerId] = useState("");
  const [name, setName] = useState("");
  const [values, setValues] = useState([""]);

  const handleValueChange = (index, value) => {
    const updatedValues = [...values];
    updatedValues[index] = value;
    setValues(updatedValues);
  };

  const handleAddValue = () => {
    setValues([...values, ""]);
  };

  const handleRemoveValue = (index) => {
    if (values.length === 1) return;

    const updatedValues = values.filter(
      (_, i) => i !== index
    );

    setValues(updatedValues);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const filteredValues = values
      .map((value) => value.trim())
      .filter((value) => value !== "");

    if (!customerId) {
      enqueueSnackbar("Customer ID is required", {
        variant: "error",
      });
      return;
    }

    if (!name.trim()) {
      enqueueSnackbar("Name is required", {
        variant: "error",
      });
      return;
    }

    if (filteredValues.length === 0) {
      enqueueSnackbar("At least one value is required", {
        variant: "error",
      });
      return;
    }

    const payload = {
      customerId: Number(customerId),
      name: name.trim(),
      values: filteredValues,
    };

    try {
      const response =
        await mgmtVariantOptions.createVariantOption(payload);
      enqueueSnackbar(
        "Variant Option created successfully",
        {
          variant: "success",
        }
      );

      // Go back to list only AFTER POST succeeds
      navigate("/app/management/variant-options");

    } catch (error) {
      enqueueSnackbar(
        "Failed to create Variant Option",
        {
          variant: "error",
        }
      );
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography
        variant="h4"
        sx={{ mb: 3 }}
      >
        Add Variant Options
      </Typography>

      <Card>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>

              {/* Customer ID */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Customer ID"
                  value={customerId}
                  onChange={(event) =>
                    setCustomerId(event.target.value)
                  }
                  type="number"
                />
              </Grid>

              {/* Name */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Name"
                  placeholder="Example: color"
                  value={name}
                  onChange={(event) =>
                    setName(event.target.value)
                  }
                />
              </Grid>

              {/* Values */}
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  sx={{ mb: 2 }}
                >
                  Values
                </Typography>

                {values.map((value, index) => (
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    sx={{ mb: 1 }}
                    key={index}
                  >
                    <Grid item xs>
                      <TextField
                        fullWidth
                        label={`Value ${index + 1}`}
                        value={value}
                        onChange={(event) =>
                          handleValueChange(
                            index,
                            event.target.value
                          )
                        }
                      />
                    </Grid>

                    <Grid item>
                      <IconButton
                        color="error"
                        onClick={() =>
                          handleRemoveValue(index)
                        }
                        disabled={values.length === 1}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}

                <Button
                  type="button"
                  startIcon={<AddIcon />}
                  onClick={handleAddValue}
                  sx={{ mt: 1 }}
                >
                  Add Value
                </Button>
              </Grid>

              {/* Buttons */}
              <Grid item xs={12}>

                {/* IMPORTANT: No onClick here */}
                <Button
                  type="submit"
                  variant="contained"
                >
                  Save
                </Button>

                <Button
                  type="button"
                  sx={{ ml: 2 }}
                  onClick={() =>
                    navigate(
                      "/app/management/variant-options"
                    )
                  }
                >
                  Cancel
                </Button>

              </Grid>

            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default VariantOptionsForm;